export enum ActionType {
  Long = 'Long',
  Short = 'Short',
}

export enum TransactionType {
  BUY = 'Buy',
  SELL = 'Sell',
}
